import {Card, CardContent,} from "@/components/ui/card"
import {Button, Divider, Input} from "antd";
import {Label} from "@/components/ui/label";
import React, {useRef, useState} from "react";
import {toast} from "react-toastify";
import {useApiAuthOtp} from "@/api/auth";
import {formatMobileNumber} from "@/lib/utils/number";
import AuthCardHeaderSection from "@/pages/auth/_section/AuthCardHeaderSection";
import {AuthFooterLinkNewMobileSection} from "@/pages/auth/_section/AuthFooterLinkNewMobileSection";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
import {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

export default function StateRecoverySection({changeMyState, myMobile, setMyMobile, state, setMyData}) {


    let passwordRef = useRef(null);
    let rePasswordRef = useRef(null);

    const {mutate: AuthSendOtp, isPending} = useApiAuthOtp()

    const [myPassword, setMyPassword] = useState('')

    const [myOtpToken, setMyOtpToken] = useState('')

    function submitForm() {


        if (!passwordRef.current.input.value) {
            toast.error('لطفا کلمه عبور خود را وارد کنید')
            passwordRef.current.focus()
            return;
        }

        if (!rePasswordRef.current.input.value) {
            toast.error('لطفا تکرار کلمه عبور خود را وارد کنید')
            rePasswordRef.current.focus()
            return;
        }

        if (passwordRef.current.input.value !== rePasswordRef.current.input.value) {
            toast.error('کلمه عبور و تکرار کلمه عبور باهم برابر نیستند')
            rePasswordRef.current.focus()
            return;
        }

        if (passwordRef.current.input.value.length < 8) {
            toast.error('کلمه عبور حداقل باید ۸ کاراکتر باشد')
            passwordRef.current.focus()
            return;
        }


        AuthSendOtp({
            mobile: formatMobileNumber(myMobile),
        }, {
            onSuccess: (data) => {
                setMyData({
                    otpToken: data?.data?.data?.otp_token,
                    password: passwordRef.current.input.value,
                    callFrom: 'recovery'
                })

                changeMyState('otp')
            }, onError: (error) => {
                ApiHandleErrorMessage(error);
            }
        })
    }


    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            submitForm()
        }
    };


    return (
        <Card>
            <AuthCardHeaderSection title={'بازیابی کلمه عبور'}
                                   description={'یک کلمه عبور جدید برای حساب کاربری خود انتخاب کنید تا با رمز فراموش شده جایگزین شود'}/>
            <CardContent>

                <div className="flex flex-col gap-6">

                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="password">کلمه عبور جدید</Label>

                        </div>
                        <Input.Password
                            onKeyDown={handleKeyDown}
                            iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                            autoComplete="off"
                            disabled={isPending}
                            ref={passwordRef}
                            id="password" type="password" required/>


                    </div>
                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="repassword">تکرار کلمه عبور جدید</Label>

                        </div>
                        <Input.Password
                            onKeyDown={handleKeyDown}
                            iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                            autoComplete="off"
                            disabled={isPending}
                            ref={rePasswordRef}
                            id="repassword" type="password" required/>


                    </div>
                    <Button
                        loading={isPending}
                        onClick={() => submitForm()}
                        type="primary" className="w-full">
                        بازیابی کلمه عبور
                    </Button>

                </div>

                <Divider type={'horizontal'}/>
                <div className="mt-4 text-center text-sm">

                    کلمه عبور خود را به خاطر آوردید؟{" "}
                    <Button type={'link'} onClick={() => changeMyState('login')}>
                        وارد شوید
                    </Button>

                </div>
                <AuthFooterLinkNewMobileSection myMobile={myMobile} changeMyState={changeMyState}/>

            </CardContent>
        </Card>

    );
}
